import React from "react";

const Badge = ({ color, children }) => {
  return <div className={`badge bg-${color}`}>{children}</div>;
};

export default Badge;
